import { TemplateData, TemplateParams } from '.';

const achievementRequestTaskListGranted = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'achievements',
  email: {
    buttonEnabled: true,
    buttonLink: '{{achievementUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.achievementRequestTaskListGrantedDescription}
        ${messages.achievementRequestSeeDetails}
      </p>
      <p>
        {{optionalMessage}}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.achievementRequestTaskListGranted}`
  },
  placeholders: {
    achievementTitle: {
      label: messages.achievementTitle,
      example: 'Test achievement'
    },
    achievementUrl: {
      label: messages.achievementLink,
      example: `${serverConfig.adminUrl}/achievements/1`
    },
    optionalMessage: {
      label: messages.commonMessageFromAdmin,
      example: 'Here is your achievement.'
    },
    ...defaultPlaceholders
  },
  title: messages.achievementRequestTaskListGranted
});

export default achievementRequestTaskListGranted;
